import React, { useEffect, useState } from "react";
import { FaRegBookmark } from "react-icons/fa";
import { AiOutlineRight } from "react-icons/ai";
import { NavLink, useParams } from "react-router-dom";
import Toast from "../components/Toast/Toast";
import { useMutation, useQuery } from "react-query";
import { API, headerConfig, publicUrl } from "../config/api";
import ScreenLoader from "../components/Skeleton/ScreenLoader";
import parse from "html-react-parser";

function DetailBook(props) {
  const { id } = useParams();
  const [show, setshow] = useState(false);

  // eslint-disable-next-line
  const { isLoading, error, data: book, refetch } = useQuery("getDetail", () =>
    API.get(`/book/${id}`)
  );
  // Use Mutation For Add To Libarary
  const [addLibrary] = useMutation(async () => {
    try {
      await API.post("/library", { bookId: id }, headerConfig);
    } catch (err) {
      console.log(err);
    }
  });
  // Getting Library Data
  const {
    isLoading: libraryLoading,
    error: libraryError,
    data: library,
    refetch: libraryRefetch,
  } = useQuery("getLibrary", () => API.get(`/library?bookId=${id}`));
  // Use Mutation when remove Library
  const [removeLibrary] = useMutation(async () => {
    try {
      await API.delete(`/library/${id}`);
    } catch (err) {
      console.log(err);
    }
  });
  // Use Effect If Show Toggler
  useEffect(() => {
    libraryRefetch();
  }, [show]);
  // Handler For Add Library
  const addLibraryHandler = () => {
    addLibrary();
    libraryRefetch();
    setshow(!show);
  };
  // Handler For Remove Library
  const removeLibraryHandler = () => {
    removeLibrary();
    libraryRefetch();
    setshow(!show);
  };
  return (
    <>
      {isLoading || !book ? (
        <ScreenLoader />
      ) : error ? (
        <p> {error.message}</p>
      ) : (
        <>
          <div className="py-6 px-4 ">
            <div>
              <div className="grid md:grid-cols-2">
                <div>
                  <img
                    className="mx-auto w-9/12 rounded-md"
                    style={{ height: "80%" }}
                    src={`${publicUrl}/${book.data.data.thumbnailImg}`}
                    alt=""
                  />
                </div>
                <div>
                  {/* Top */}
                  <div>
                    <h1
                      className="text-6xl font-bold"
                      style={{ fontFamily: "Times New Roman" }}
                    >
                      {book.data.data.title}
                    </h1>
                    <p className="text-2xl text-gray-600 mt-2">
                      {book.data.data.user.fullName}
                    </p>
                  </div>
                  {/* Bot */}
                  <div className="mt-12">
                    <p className="text-2xl font-bold">Publication date</p>
                    <p className="text-gray-600 text-xl mb-8">
                      {book.data.data.publication}
                    </p>
                    <p className="text-2xl font-bold">Category</p>
                    <p className="text-gray-600 text-xl mb-8">
                      {book.data.data.category.name}
                    </p>
                    <p className="text-2xl font-bold">Pages</p>
                    <p className="text-gray-600 text-xl mb-8">
                      {book.data.data.pages}
                    </p>
                    <p className="text-2xl font-bold text-orange-custom">
                      ISBN
                    </p>
                    <p className="text-gray-600 text-xl mb-8">
                      {book.data.data.ISBN}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="block w-11/122 mx-auto mb-16">
              <hr className="border-1" />
            </div>
            <div className="mb-4">
              <h1
                className="text-4xl font-bold h-20 mb-4"
                style={{ fontFamily: "Times New Roman" }}
              >
                About This Book
              </h1>
              {parse(book.data.data.aboutBook)}
            </div>
            <div className="flex w-full justify-end">
              <div className="">
                {libraryLoading || !library ? (
                  libraryError ? (
                    ""
                  ) : (
                    ""
                  )
                ) : !library.data.data ? (
                  <button
                    onClick={() => addLibraryHandler()}
                    className="focus:outline-none bg-orange-custom text-white px-4 mr-4 py-3 rounded-md text-lg flex"
                  >
                    Add Library
                    <FaRegBookmark className="ml-2 place-self-center" />
                  </button>
                ) : (
                  <button
                    onClick={() => removeLibraryHandler()}
                    className="focus:outline-none bg-orange-custom text-white px-4 mr-4 py-3 rounded-md text-lg flex"
                  >
                    Remove Library
                    <FaRegBookmark className="ml-2 place-self-center" />
                  </button>
                )}
              </div>
              <div>
                <NavLink
                  to={"/read/" + id}
                  className="focus:outline-none bg-gray-200 px-4 flex  py-3 rounded-md text-lg"
                >
                  Read Book
                  <AiOutlineRight className="ml-3 place-self-center" />
                </NavLink>
              </div>
            </div>
          </div>
          <Toast
            toggleToast={() => setshow(!show)}
            show={show}
            title={
              libraryLoading || !library
                ? ""
                : library.data.data
                ? "Successfully remove book"
                : "Your book has been added successfully"
            }
          />
        </>
      )}
    </>
  );
}

export default DetailBook;
